import { render, staticRenderFns } from "./slaccountlog.vue?vue&type=template&id=710fc115&"
import script from "./slaccountlog.vue?vue&type=script&lang=js&"
export * from "./slaccountlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports